module.exports = __webpack_public_path__ + "img/sbp_2.f9d7e1e0.svg";